<template>
    <div :class="{'i18n_container': true}">
      <div v-if="value == ''" label="KEY">
        <span>KEY 不存在，系统异常</span>
        </div>
      <div>
       中文： <span>{{ formRecord.lang_zh }}</span>
      </div>
      <div>
        英文： <span>{{ formRecord.lang_en }}</span>
      </div>
      <div style="display: flex; flex-direction: row; justify-content: space-between;">
        <span v-show="loading">Loading ...</span>
      </div>
    </div>
   
  </template>
  <script>
  
  import { defineComponent, reactive, ref } from 'vue'
  import request from '@/utils/request'
  import { Modal, message } from 'ant-design-vue';
  import OSS from 'ali-oss'

  const FormRecord = {
    id: 0,
    uniq_key: '',
    lang_zh: '',
    lang_en: '',
    lang_jp: '',
    lang_kr: '',
    lang_th: '',
  }
  let inputDebounceTimer = null
  export default defineComponent({
    emits: ['ok', 'update:valid', 'update:zh', 'change'],
    props: ['value',  'valid', 'showTitle'],
    components:{
      
    },
    data(){
      return {
        loading: false,
        openDia: false,
        changed: true,
        formRecord: {
          ...FormRecord,
        },
      }
    },
    mounted() {
      this.GetByKey()
    },
    methods: {
      genkey(){
        return this.value
      },
      async GetByKey(){
        this.loading = true
        const rsp = await request.get(`/api/i18n/texts/key`, {
          key: this.genkey(),
        })
        if (rsp.data.result) {
          this.formRecord = rsp.data.result
          this.$emit('update:valid', true)
          this.$emit('update:zh', this.formRecord.lang_zh)
          this.changed = false
        } else {
          this.formRecord = {
            ...FormRecord,
          }
          this.$emit('update:valid', false)
          this.changed = true

        }
        this.loading = false
         
      },
      async handleConfirm(){
        this.loading = true
        if (this.formRecord.lang_zh == '') {
          message.error('请输入中文文案')
          return
        }
        if (this.formRecord.lang_en == '') {
          message.error('请输入英文文案')
          return
        }
        if (this.formRecord.id) {
          const rsp = await request.put(`/api/i18n/texts/${this.formRecord.id}`, {
            ...this.formRecord,
            uniq_key: this.genkey(),
          })
        } else {
          const rsp = await request.post('/api/i18n/texts', {
            ...this.formRecord,
            uniq_key: this.genkey(),
          })
          this.formRecord.id = rsp.data.id
        }
        this.changed = false
        this.$emit('update:valid', true)
        this.$emit('update:zh', this.formRecord.lang_zh)
        this.loading = false
      },
      handleChange(){
        this.changed = true
        this.$emit('change', this.formRecord)
        this.$emit('update:valid', false)
      }
    },
  })
  </script>
  <style  scoped>
  .green-btn:hover{
    color: #EEE;
    border:1px solid #EEE;
  }
  .i18n_container_changed {
    background: #fff2f0 !important;
  }
  .i18n_container {
    padding: 8px;
  }
  </style>